module.exports = {
	"@extends": "../config.json5",
	"auth": {
		"auth0": {
			"clientId": "rhurcsq6f1EaW6Puo7QuPQCht7izsBqr",
			"url": "https://gw-test.eu.auth0.com",
			"redirectPath": "/dist/html/common/login-redirect.html"
		}
	},
	"userSettings": {
		"sessionConfig": {
			"inactivityIntervalMins": 10
		}
	}
}